module.exports = __webpack_public_path__ + "media/images/front/icons/phone-white-580c957055c7db389c9580d3659044c7.svg";